var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-rules flex items-center justify-center w-full",class:_vm.classes},[_c('div',[_c('div',{staticClass:"text-center m-b",staticStyle:{"color":"#BBBBBB","font-size":"80px"}},[_c('u-icon',{attrs:{"name":"code-branch","type":"fa","icon-style":"light"}})],1),_c('div',[_vm._v("Regras não disponível nesta versão")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }